import script from "./TeacherSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherSchedule.vue?vue&type=script&setup=true&lang=js"

import "./TeacherSchedule.vue?vue&type=style&index=0&id=7c48dc00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c48dc00"]])

export default __exports__